import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DynamicReportsService {

   private url = environment.api + 'api/erp/dynamic-reports';

  constructor(
    private http: HttpClient,
  ) { }


  getClientSalesReport(request: any) {
    return this.http.post(this.url + "/client-sales", request);
  }

  getProviderSalesReport(request: any) {
    return this.http.post(this.url + "/provider-sales", request);
  }

}
